import { atom, type WritableAtom } from 'nanostores'
import type { UserInfo } from './types'

export interface UserInfoSource {
  readonly atom: WritableAtom<UserInfo | null>
  get(): UserInfo | null
  getReady(): Promise<UserInfo>
  refresh(): Promise<UserInfo>
}

export interface CreateUserInfoSourceOptions {
  load: () => Promise<UserInfo>
  refresh: () => Promise<UserInfo>
}

export function createUserInfoSource(
  options: CreateUserInfoSourceOptions,
): UserInfoSource {
  const store = atom<UserInfo | null>(null)
  let loadPromise: Promise<UserInfo> | null = null

  function getReady(): Promise<UserInfo> {
    const current = store.get()
    if (current) return Promise.resolve(current)
    if (loadPromise) return loadPromise
    const inFlight = options.load().then(
      (value) => {
        store.set(value)
        return value
      },
      (error) => {
        if (loadPromise === inFlight) loadPromise = null
        throw error
      },
    )
    loadPromise = inFlight
    return loadPromise
  }

  async function refresh(): Promise<UserInfo> {
    const value = await options.refresh()
    store.set(value)
    return value
  }

  return {
    atom: store,
    get: () => store.get(),
    getReady,
    refresh,
  }
}
